<!-- 新增stock详情 -->
<template>
<el-dialog :title="msg('新增')" :visible.sync="visible"
    :fullscreen="isMinScreen"
    :close-on-click-modal="false" 
    append-to-body
    width="60%"
>
    <el-form ref="form" :model="stockDetail" label-width="100px" style="margin:0 20px">
        <el-row>
            <el-col :xs="24" :sm="24">
                <el-form-item :label="msg('商品标题')">
                    <el-input v-model.trim="stockDetail.productTitle" ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :xs="24" :sm="24">
                <el-form-item :label="msg('商品规格')">
                    <el-input v-model.trim="stockDetail.productSpec" ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :xs="24" :sm="12">
                <el-form-item :label="msg('数量')">
                    <el-input-number v-model.number="stockDetail.productQty" :min="1"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
                <el-form-item :label="msg('价格(元)')">
                    <el-input type="number" v-model="stockDetail.productPrice" ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-tag type="danger">添加详情不会更新货态，如有需要请自行检查货态是否正确；</el-tag>
        </div>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button size="mini" @click="close()">{{msg('取消')}}</el-button>
        </div>
    </el-form>
</el-dialog>
</template>

<script>
export default {
    name: "AddStockDetailDialog",
    data(){
        return {
            visible: false,
            stockDetail: {
                id:null,
                productTitle:null,
                productSpec:null,
                productQty:1,
                productPrice:0,
                stockId:0,
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        }
    },
    methods: {
        showDialog(detail){

            if(!this.hasPermission("stock:detailEdit")){
                this.$message(this.msg('无操作权限'));
                return;
            }
            if(detail.status >= 13 && detail.status <= 23){
                this.visible = true;
            }else{
                if(this.hasPermission("stock:detailAdd")){
                    this.visible = true;
                }else{
                    this.$message(this.msg('该订单不能新增'));
                }
            }

            this.stockDetail = {
                id:null,
                productTitle:null,
                productSpec:null,
                productQty:1,
                productPrice:0,
                stockId:detail.stockId,
            }
        },
        onSubmit(){
            var _this = this;
            this.stockDetail.productPrice = this.stockDetail.productPrice*100;
            this.$axios.post(
                this.$kit.api.stockDetail.createDetail, 
                this.stockDetail
            ).then(function(result){
                let detailId = result.data;
                _this.stockDetail.id = detailId;
                if(result.status){
                    // _this.stockDetail.productPrice = _this.stockDetail.productPrice/100;
                    // _this.$emit("close-dg", {stockDetail: _this.stockDetail, type: true});
                    _this.finish(true);
                    _this.$message(result.msg || _this.msg("添加成功"));
                }else{
                    _this.$message(result.msg || _this.msg("添加失败"));
                }
            });
        },
        close(type){
            this.finish(false);
        },
        finish(type){
            this.stockDetail.productPrice = this.stockDetail.productPrice/100;
            this.$emit("finish", {stockDetail: this.stockDetail, type: type});
            this.visible = false;
        }
    }
}
</script>